import { t } from 'i18next';
import React from 'react';

export function Guideline(importType, path) {
  switch (path) {
    case '/items/import':
      return renderItemGuideline(importType);
    case '/contacts/import':
      return renderContactGuideline(importType);
    default:
      // do nothing;
      break;
    // return <div>Please select any from "Import From" to continue..</div>
  }
}

function renderItemGuideline(importType) {
  switch (importType) {
    case 'seebiz':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong> -  {t("Contacts.download_this")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_SeeBiz_Items.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >  {t("Contacts.sample_file")}
          </a>
          <br />
          <strong>{t("Contacts.Step_two")}</strong>{t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>” {t("Contacts.and_save_csv")} <br />
          <strong>{t("Contacts.Step_three")}</strong> {t("Contacts.edit_fill_data")}
          <br />
          <strong>{t("Contacts.Step_four")}</strong>  {t("Contacts.save_file_in_our_system")}
        </div>
      );

    case 'zoho':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong>{t("Contacts.open")}<b>{t("Contacts.items_listing")}</b> {t("Contacts.from_your_zoho_account")}<br />
          <strong>{t("Contacts.Step_two")}</strong>{t("Contacts.click_the")} "<u>{t("Contacts.export_button")}</u>". {t("Contacts.access")} <br />
          <strong>{t("Contacts.Step_three")}</strong> - {t("Contacts.select_module")} “<u>{t("Contacts.items")}</u>”,{t("Contacts.and_select")}  “
          <u>{t("Contacts.all_items")}</u>” {t("Contacts.via_radio_button")} <br />
          <strong>{t("Contacts.Step_four")}</strong> {t("Contacts.select")} “<u>{t("Contacts.csv")}</u>“ {t("Contacts.as_export_format")} <br />
          <strong>{t("Contacts.Step_five")}</strong> - {t("Contacts.keep")} "
          <u>{t("Contacts.password_protection_disabled")}</u>". <br />
          <strong>{t("Contacts.Step_six")}</strong> {t("Contacts.click_export")} "<u>{t("Contacts.export")}</u>" {t("Contacts.to_download")}. <br />
          <strong>{t("Contacts.Step_seven")}</strong>  {t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>”, {t("Contacts.and_save_csv")}. <br />
          <strong>{t("Contacts.Step_eight")}</strong>  {t("Contacts.exported_file_should_item")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_Zoho_Export_Items.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.sample_file")}           </a>
          <br />
          <strong>{t("Contacts.Step_nine")}</strong> {t("Contacts.now_upload_our_system")}
        </div>
      );

    case 'quickbookc':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong>  {t("Contacts.open")} <b>{t("Contacts.product_services_lisiting")}</b> {t("Contacts.from_your_quikbooks_account")} <br />
          <strong>{t("Contacts.Step_two")}</strong> {t("Contacts.click_the")} “<u>{t("Contacts.export_to_excel")}</u>“ {t("Contacts.icon_at_the_top_right")} <br />
          <strong>{t("Contacts.Step_three")}</strong>  {t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>” {t("Contacts.and_save_csv")} <br />
          <strong>{t("Contacts.Step_four")}</strong> - {t("Contacts.the_final_file")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBook_Export_Product_Service_List.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.product_services_sample_file")}
          </a>
          <br />
          <strong>{t("Contacts.Step_five")}</strong>  {t("Contacts.now_upload_our_system")}
        </div>
      );
    case 'quickbookr':
      return (
        <div>
          {' '}
          <strong>{t("Contacts.Step_one")}</strong> {t("Contacts.click_on_the")} <b>{t("Contacts.gear")}</b> {t("Contacts.icon_at_the_right")} <br />
          <strong>{t("Contacts.Step_two")}</strong> {t("Contacts.select")}"<u>{t("Contacts.export_data")}</u>" {t("Contacts.under_the")}{' '}
          <u>{t("Contacts.tools")}</u> {t("Contacts.section")} <br />
          <strong>{t("Contacts.Step_three")}</strong> - {t("Contacts.click_on")} “<u>{t("Contacts.visit_the_reports_page")}</u>“
          {t("Contacts.link_at_the_top_right_coner")} <br />
          <strong>{t("Contacts.Step_four")}</strong> - {t("Contacts.look_for")} "<u>{t("Contacts.product_service_list")}</u>"
          {t("Contacts.option_under_the_sales_and_customer_panel")} <br />
          <strong>{t("Contacts.Step_five")}</strong> {t("Contacts.click_run_report")} <br />
          <strong>{t("Contacts.Step_six")}</strong> - {t("Contacts.edit_file_way")} <br />
          <strong>{t("Contacts.Step_seven")}</strong> {t("Contacts.save_file_as_csv_format")} <br />
          <strong>{t("Contacts.Step_eight")}</strong> -{t("Contacts.the_final_file")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBook_Report_ProductService_List.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.product_services_sample_file")}
          </a>{' '}
          <br />
          <strong>{t("Contacts.Step_nine")}</strong>{t("Contacts.now_upload_our_system")}
        </div>
      );
    default:
      // do nothing;
      return <div>{t("Contacts.please_select_any_sales")}</div>;
  }
}

function renderContactGuideline(importType) {
  switch (importType) {
    case 'seebiz':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong> - {t("Contacts.download_this")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_SeeBiz_Contacts.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.sample_file")}          </a>
          <br />
          <strong>{t("Contacts.Step_two")}</strong>{t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>”, {t("Contacts.operator_save_scv")} <br />
          <strong>{t("Contacts.Step_three")}</strong> {t("Contacts.edit_fill_data_accordingly")}
          <u>{t("Contacts.vendor")}</u>" {t("Contacts.or")} "<u>{t("Contacts.customer")}</u>" {t("Contacts.text_under_contact")}
          <br />
          <strong>{t("Contacts.Step_four")}</strong>{t("Contacts.contact_type_not_available")} <u>{t("Contacts.customer")}</u>".
          <br />
          <strong>{t("Contacts.Step_five")}</strong>{t("Contacts.save_file_in_our_system")}
        </div>
      );

    case 'zoho':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong> {t("Contacts.open")} <b>{t("Contacts.customer_vendors_listing")}</b>{t("Contacts.from_your_zoho_account")}<br />
          <strong>{t("Contacts.Step_two")}</strong>{t("Contacts.click")} <u>{t("Contacts.export_button")}</u>{t("Contacts.access")} <br />
          <strong>{t("Contacts.Step_three")}</strong> {t("Contacts.select_module")}“<u>{t("Contacts.customer")}</u>” {t("Contacts.or")} “
          <u>{t("Contacts.vendors")}</u>“{t("Contacts.select_only_customer")} <br />
          <strong>{t("Contacts.Step_four")}</strong>{t("Contacts.contact_type_not_available")}"<u>{t("Contacts.customer")}</u>".
          <br />
          <strong>{t("Contacts.Step_five")}</strong> {t("Contacts.select")} “<u>{t("Contacts.contacts_csv")}</u>“ {t("Contacts.as_export_format")} <br />
          <strong>{t("Contacts.Step_six")}</strong> {t("Contacts.keep_the")} "
          <u>{t("Contacts.password_protection_disabled")}</u>". <br />
          <strong>{t("Contacts.Step_seven")}</strong>{t("Contacts.click_export")} "<u>{t("Contacts.export")}</u>"  {t("Contacts.to_download")}<br />
          <strong>{t("Contacts.Step_eight")}</strong> {t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>”{t("Contacts.and_save_csv")} <br />
          <strong>{t("Contacts.Step_nine")}</strong> {t("Contacts.exported_file_should")}
          {' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_Zoho_Export_Customers.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.customer_sample_file")}
          </a>{' '}
          {t("Contacts.OR")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_Zoho_Export_Vendors.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.vendor_sample_file")}
          </a>{' '}
          <br />
          <strong>{t("Contacts.step_ten")}</strong> {t("Contacts.now_upload_our_system")}
        </div>
      );

    case 'quickbookc':
      return (
        <div>
          <strong>{t("Contacts.Step_one")}</strong> {t("Contacts.open")} <b>{t("Contacts.customer_suppliers_listing")}</b> {t("Contacts.from_your_quikbooks_account")}<br />
          <strong>{t("Contacts.Step_two")}</strong> {t("Contacts.click_the")} “<u>{t("Contacts.export_to_excel")}</u>“ {t("Contacts.icon_at_the_top_right")} <br />
          <strong>{t("Contacts.Step_three")}</strong> {t("Contacts.open_file_in_excel")} “
          <u>{t("Contacts.save_as")}</u>”, {t("Contacts.operator_save_scv")} <br />
          <strong>{t("Contacts.Step_four")}</strong> - {t("Contacts.the_final_file")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBook_Export_Customers.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.customer_sample_file")}</a>{' '}
          {t("Contacts.OR")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBooks_Export_Supplier.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.supplier_sample_file")}</a>{' '}
          <br />
          <strong>{t("Contacts.Step_five")}</strong> {t("Contacts.now_upload_our_system")}
        </div>
      );
    case 'quickbookr':
      return (
        <div>
          {' '}
          <strong>{t("Contacts.Step_one")}</strong>{t("Contacts.click_on_the")}  <b>{t("Contacts.gear")}</b> {t("Contacts.icon_at_the_right")} <br />
          <strong>{t("Contacts.Step_two")}</strong> {t("Contacts.select")} "<u>{t("Contacts.export_data")}</u>"{t("Contacts.under_the")}{' '}
          <u>{t("Contacts.tools")}</u> {t("Contacts.section")} <br />
          <strong>{t("Contacts.Step_three")}</strong> {t("Contacts.go_to")} "<u>{t("Contacts.list_tab")}</u>" {t("Contacts.select_either")} "
          <u>{t("Contacts.customers")}</u>" {t("Contacts.or")} "<u>{t("Contacts.suppliers")}</u>". <br />
          <strong>{t("Contacts.Step_four")}</strong> {t("Contacts.click")} "<u>{t("Contacts.export_to_excel")}</u>"{t("Contacts.button")}  <br />
          <strong>{t("Contacts.Step_five")}</strong>{t("Contacts.unzip_the_file")} <br />
          <strong>{t("Contacts.Step_six")}</strong> - {t("Contacts.edit_file_way")} <br />
          <strong>{t("Contacts.Step_seven")}</strong> - {t("Contacts.save_the_file_as")} "<u>.{t("Contacts.csv")}</u>" {t("Contacts.format")}{' '}
          <br />
          <strong>{t("Contacts.Step_eight")}</strong> - {t("Contacts.the_final_file")}{' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBook_Report_Customers.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.supplier_sample_file")}
          </a>{' '}
          {t("Contacts.OR")} {' '}
          <a
            href={`${process.env.REACT_APP_AMAZON_S3}/sample-files/sample_QuickBook_Report_Suppliers.csv`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("Contacts.supplier_sample_file")}
          </a>{' '}
          <br />
          <strong>{t("Contacts.Step_nine")}</strong> {t("Contacts.now_upload_our_system")}
        </div>
      );
    default:
      // do nothing;
      // break;
      return <div>{t("Contacts.please_select_any_sales")}</div>;
  }
}
